import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getCasesPage, type CaseListPage } from "../index";
import { caseCheckKeys, type CaseCheckCasesPageParams } from "./keys";
import { caseCheckQueryDefaults } from "./options";

type Options = Omit<UseQueryOptions<CaseListPage>, "queryKey" | "queryFn">;

export function useCaseCheckCasesPage(params: CaseCheckCasesPageParams, options?: Options) {
  return useQuery({
    queryKey: caseCheckKeys.casesPage(params),
    queryFn: () =>
      getCasesPage({
        skip: params.skip,
        limit: params.limit,
        stage: params.stage,
        grade: params.grade,
      }),
    ...caseCheckQueryDefaults,
    ...options,
  });
}
